import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7aad29e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row-span-1 text-sm sm:text-base lg:text-sm xl:text-base" }
const _hoisted_2 = { class: "font-bold text-xl sm:text-4xl lg:text-xl xl:text-4xl" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "w-fit row-span-2 mx-auto sm:mx-0" }
const _hoisted_5 = { class: "row-span-2 my-10 p-6 max-w-sm h-fit bg-white rounded-lg border border-gray-200 shadow-md dark:bg-gray-800 dark:border-gray-700 text-sm sm:text-base lg:text-sm xl:text-base" }
const _hoisted_6 = { class: "row-span-1 text-sm sm:text-base lg:text-sm xl:text-base mt-6" }

import DiagnosticSection from '@/components/video-diagnostic/DiagnosticSection.vue'
import { Stage } from '@/types/enums/zoom-diagnostic.enum'
import ConnectionCard from '@/components/video-diagnostic/ConnectionCard.vue'

interface ConnectionSuccessEmits {
  (e: 'nextStage'): void
  (e: 'updateToggle'): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ConnectionSuccess',
  props: {
  stage: {
    type: Number,
    required: true,
  },
},
  emits: ["nextStage", "updateToggle"],
  setup(__props, { emit: __emit }) {



const emit = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DiagnosticSection, {
    id: _unref(Stage).CONNECTIVITY,
    class: _normalizeClass(
      __props.stage === _unref(Stage).CONNECTIVITY || __props.stage === _unref(Stage).RESULTS
        ? 'block'
        : 'hidden md:block opacity-30 pointer-events-none'
    )
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('zoom-diagnostic.connection-success')), 1),
        _createElementVNode("p", {
          class: "py-4 sm:py-10 lg:py-4 xl:py-10",
          innerHTML: _ctx.$t('zoom-diagnostic.connection-success-detail')
        }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(ConnectionCard)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          class: _normalizeClass([{ 'opacity-30 pointer-events-none': __props.stage === _unref(Stage).RESULTS }, "text-white border-2 rounded-md border-white bg-primary-color py-2 px-4"]),
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('nextStage')))
        }, _toDisplayString(_ctx.$t('zoom-diagnostic.ok')), 3)
      ])
    ]),
    _: 1
  }, 8, ["id", "class"]))
}
}

})